import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

/**
 * 区块容器：标题在设计稿里是一张 PNG（艺术字），爬虫与读屏软件读不到。
 *
 * 传入 title（标题文本）后，会把图片包进真实的语义标题标签里，
 * 文本以 .sr-only 的方式渲染——视觉上仍是原来的图，
 * 但 HTML 里多了一条可被抓取、可被 AI 引擎引用的 h2/h3。
 * 不传 title 时保持老行为（只有图片 + alt），避免影响其它页面。
 */
const Introduce = ({
  title,
  titleLevel = "h2",
  src,
  backgroundColor,
  alt,
  childrenIsWrapped,
  childrenWrapperStyle,
  wrapperStyle,
  children,
}) => {
  const Heading = titleLevel;

  return (
    <Wrapper style={{ backgroundColor, ...wrapperStyle }}>
      {title ? (
        <Heading className="section_title">
          <span className="sr-only">{title}</span>
          {src && <img className="title_img" src={src} alt="" />}
        </Heading>
      ) : src ? (
        <img className="title_img" src={src} alt={alt} />
      ) : (
        /*
         * 既没传 title 也没传 src：改造前这里会渲染一张无 src 的 <img class="title_img">，
         * 它高度为 0，唯一的作用是撑出和标题一样的上边距（第二组企业荣誉卡片就依赖这个间距）。
         * 用同宽高的空 div 占位，保证视觉不发生变化。
         */
        <div className="title_img" />
      )}
      {childrenIsWrapped ? (
        <div style={childrenWrapperStyle}>{children}</div>
      ) : (
        children
      )}
    </Wrapper>
  );
};

export default Introduce;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  > .title_img,
  > .section_title > .title_img {
    margin-top: 24px;
    width: 305px;
  }
  > .section_title {
    /* 覆盖 base.css 里 h1~h6 的默认外边距，保证视觉与改造前一致 */
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  ${breakpoint("desktop")`
    > .title_img,
    > .section_title > .title_img {
      margin-top: 66px;
      width: 642px;
    }
  `}
`;
